import React, { Component } from "react";
import { string } from "prop-types";

class InfoTag extends Component {
    static propTypes = {
        message: string.isRequired,
        tagBackground: string,
        tagClass: string,
    };

    static defaultProps = {
        tagBackground: "#cdcdcd",
        tagClass: "",
    };

    render() {
        const { message, tagBackground, tagClass } = this.props;
        return <div className={`tag tag-${tagBackground} ${tagClass} text-capitalize`}>{message?.toLowerCase()}</div>;
    }
}

export default InfoTag;
